import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Globals } from 'src/shared/globals';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root' // Makes the service a singleton available throughout the app
})
export class ChangePasswordService {
  constructor(private httpClient: HttpClient, private global: Globals) {}

  PostService(endPoint: string, body: any): Observable<any> {
    const url = `${this.global.apiUrl}ForgotPassword/${endPoint}`;
    return this.httpClient.post(url, body);
  }

  GetService(endPoint: string, body?: any): Observable<any> {
    const url = `${this.global.apiUrl}ForgotPassword/${endPoint}`;
    return this.httpClient.get(url, body);
  }
}
